import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { acquiredMergerNameConfig } from './AcquiredMerger.name';

enum AcquiredMerger {
  mergedAssets = '1',
  other = '2',
}

const acquiredMergerMap = new Map([
  ['1', AcquiredMerger.mergedAssets],
  ['2', AcquiredMerger.other],
]);

const rawValueToAcquiredMerger = rawValueToEnumWithDefault(acquiredMergerMap, AcquiredMerger.mergedAssets);

const acquiredMergerToDisplay = enumToNameWithDefault(AcquiredMerger, acquiredMergerNameConfig);

const acquiredMergerToDisplayWithPrefix = enumToNameWithDefault(
  AcquiredMerger,
  acquiredMergerNameConfig,
  true,
);

export {
  AcquiredMerger,
  acquiredMergerToDisplay,
  acquiredMergerToDisplayWithPrefix,
  rawValueToAcquiredMerger,
};
